import type { TaxInvoiceServiceIBSCBSInputDto } from '../tax-invoices/tax-invoice-service.entity'
import type { TaxParamNfseIssuerEnum, TaxParamStreetTypeEnum } from './tax-param.enum'

export class TaxParamEntity {
    taxParamId: string
    companyId: string
    createdAt: Date
    updatedAt: Date
    city: string
    state: string
    streetType: TaxParamStreetTypeEnum
    street: string
    addressNumber: string
    addressComplement?: string
    neighborhood: string
    zipCode: string
    phone: string
    email: string
    logo?: string
    companyName: string
    companyLegalName: string
    document: string
    municipalReg?: string
    stateReg?: string
    ibgeCode?: string
    taxIsSimplesNacional: boolean
    taxRegime: number
    taxRegimeSpecial: number
    taxIncentive: boolean
    nfseActive: boolean
    nfseProduction: boolean
    nfseConfigIsNacional: boolean
    nfseConfigVersaoEsquema: string
    nfseConfigMunicipalLogin?: string
    nfseConfigMunicipalPasswrod?: string
    nfseConfigMunicipalGrossRevenue?: number
    nfseConfigMunicipalLaw?: string
    nfseConfigMunicipalInitialDate?: Date
    nfseConfigRPSNumberingNumber?: number
    nfseConfigRPSNumberingSeries?: string
    nfseDefaultServiceCode: string
    nfseDefaultServiceTaxCode: string
    nfseDefaultServiceTaxRate: number
    nfseDefaultServiceISSRetido: number
    nfseDefaultServiceTaxType: number
    nfseDefaultServiceTaxSituation: number
    nfseDefaultServiceCNAE: string
    nfseDefaultServiceNBS: string
    nfseDefaultServiceCodigoCidadeIncidencia: string
    nfseDefaultServiceCodigoServicoNacional: string
    nfseDefaultServiceCodigoContribuinte: string
    nfseDefaultServiceIBSCBS: TaxInvoiceServiceIBSCBSInputDto
    // valor aproximado dos tributos (Lei 12.741/2012), em %
    nfseTotTribSN?: number
    nfseTotTribFed?: number
    nfseTotTribEst?: number
    nfseTotTribMun?: number
    nfseConfigSingleService: boolean
    nfseConfigSingleServiceDefaultDescription?: string
    nfseCustomNaturezaTributacao?: string
    nfseCustomRegimeApuracaoTributaria?: string
    nfseCustomCodigoSubItemListaServico?: string
    nfseDefaultCancellationReason?: number
    nfseDefaultCancellationReasonMessage?: string
    certPassword?: string
    certFile?: string
    notes?: string
    status: number

    syncAt?: Date
    syncStatus?: number
    syncMessage?: string

    nfseIssuer: TaxParamNfseIssuerEnum
    nfseNacionalLastNSU?: string
}
